import { Box, lighten, colors, darken } from "@mui/material";

import styled, { css } from "styled-components";

import "@fontsource/story-script";
import "@fontsource/inter";
import "@fontsource/league-spartan";
import { TemplateColorObject } from "../../../../InvitationColorMatrix";

const common_sectionBackground = css`
	background-image: url("https://storage.googleapis.com/public_viteslink_storage/images/invitation02/inivitation02background0111.png");
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
	position: relative;

	.section_content {
		position: relative;
		top: 0;
		z-index: 1;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
`;

const common_btn = (props: { colormatrix: TemplateColorObject }) => css`
	background: ${props.colormatrix.button.background};
	color: #fff;
	padding: 5px 15px;
	&.Mui-disabled {
		background: ${colors.grey[300]};
	}
`;

export const TemplateWrapper = styled(Box)<{ colormatrix: TemplateColorObject }>`
	overflow: hidden;

	.section_01 {
		.section_content {
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			position: relative;
			min-height: 100vh;

			.main_frame_wrapper {
				z-index: 1;
				margin-top: 130px;
				display: flex;
				justify-content: center;
				position: relative;

				.main_white_frame {
					background: #fff;
					box-shadow: 0 0 2px 2px #ebebeb;
					overflow: hidden;
					border-radius: 15px;
					display: flex;
				}

				.main_frame {
					width: 260px;
					min-height: 200px;
					height: auto;
					z-index: 1;
				}

				.flower_01 {
					position: absolute;
					z-index: 0;
					left: -35px;
					top: -65px;
					width: 200px;
				}

				.flower_02 {
					position: absolute;
					z-index: 2;
					bottom: -45px;
					right: -75px;
					width: 200px;
				}
			}

			.curtains {
				width: 600px;
				height: 500px;
				position: absolute;
				top: -60px;
			}

			.save_date_wrapper {
				margin: 50px 20px;
				align-self: flex-start;
				display: flex;
				flex-direction: column;
				align-items: flex-start;

				&.rtl {
					align-self: flex-end;
				}

				.partners_text {
					font-family: var(--story), sans-serif;
					font-weight: bold;
					font-size: 24px;
					color: ${props => props.colormatrix.font.primary};
				}

				.date {
					font-family: var(--league), sans-serif;
					font-size: 22px;
					color: ${props => lighten(props.colormatrix.font.secondary, 0.2)};
				}

				.counter_boxes_wrapper {
					display: flex;
					grid-gap: 20px;
					margin-top: 20px;

					.counter_box_wrapper {
						display: flex;
						flex-direction: column;
						align-items: center;
						grid-gap: 5px;

						p,
						.counter_box {
							color: #000;
							font-size: 18px;
							font-weight: bold;
							font-family: var(--inter), sans-serif;
						}
					}
				}

				button {
					${props => common_btn(props)}
					margin: 20px 0;
					color: #fff;
					padding: 10px 30px;
				}
			}
		}
	}

	.section_02 {
		background: ${props => props.colormatrix.overlay};
		//.waive {
		//	position: absolute;
		//	top: -70px;
		//	width: 100%;
		//	height: 70px;
		//}

		.section_content {
			position: relative;
			top: 0;
			z-index: 1;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			grid-gap: 15px;
			padding: 10px;
			padding-bottom: 60px;
			padding-top: 20px;

			.fader {
				height: 30px;
				width: 100%;
				background: ${props => props.colormatrix.fader};
				position: absolute;
				top: -20px;
			}

			.quran {
				margin: 25px 0px;
				font-size: 30px;
				font-family: var(--quran), sans-serif;
				text-align: center;
				line-height: 1.2;
			}

			.main_intro {
				font-family: var(--inter), sans-serif;
				font-size: 16px;
				text-align: center;
				padding: 5px 20px;
			}

			.main_sub_intro {
				font-family: var(--inter), sans-serif;
				font-size: 22px;
				color: ${lighten("#000", 0.2)};
			}

			.partner_frame_wrapper {
				background: #fff;
				border-radius: 15px;

				img {
					border-radius: 15px;
					box-shadow: 0 0 2px 2px #ebebeb;
					height: 220px;
				}
			}

			.partner_name {
				font-family: var(--story), sans-serif;
				font-size: 24px;
				font-weight: bold;
			}

			.and {
				font-family: var(--story), sans-serif;
				font-size: 24px;
				font-weight: bold;
			}
		}
	}

	.section_03 {
		background: ${props => props.colormatrix.main};
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 45px 30px;
		position: relative;

		.bismillah {
			margin-bottom: 25px;
			width: 250px;
			direction: rtl;
		}

		.quran_start {
			font-family: var(--quran);
			font-size: 22px;
			color: ${props => props.colormatrix.font.tertiary};
			text-align: center;
			font-weight: bold;
			margin-bottom: 25px;
			direction: rtl;
		}

		.quran {
			font-family: var(--quran);
			font-size: 22px;
			color: ${props => props.colormatrix.font.tertiary};
			text-align: center;
			font-weight: bold;
			direction: rtl;
		}

		.quran_end {
			font-family: var(--quran);
			font-size: 22px;
			color: ${props => props.colormatrix.font.tertiary};
			text-align: center;
			margin-top: 25px;
			font-weight: bold;
			direction: rtl;
		}

		//.waive {
		//	position: absolute;
		//	top: 0;
		//	width: 100%;
		//	height: 70px;
		//	top: -70px;
		//}
	}

	.section_04 {
		background: ${props => props.colormatrix.overlay};
		.section_content {
			position: relative;
			top: 0;
			z-index: 1;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			padding: 10px;

			.flower_03 {
				position: absolute;
				top: -55px;
				left: -80px;
				width: 180px;
			}

			.section_title {
				font-family: var(--league), sans-serif;
				color: ${props => props.colormatrix.font.primary};
				font-size: 28px;
				margin-top: 35px;
			}

			.love_story_wrapper {
				width: 100%;
				display: flex;
				justify-content: center;
				position: relative;
				margin: 30px 0;

				.story_image {
					max-width: 350px;
					background: #fff;
					border-radius: 10px;
				}

				.story_image_tag {
					position: absolute;
					top: -25px;
					left: -10px;
					z-index: 1;
				}
			}

			.stories {
				display: flex;
				flex-direction: column;
				margin-top: 30px;
				margin-bottom: 50px;
				min-width: 330px;

				.story {
					display: flex;
					flex-direction: column;
					align-items: center;
					padding: 10px 20px;

					p {
						font-family: var(--inter), sans-serif;
						font-size: 20px;
						font-weight: 400;
						text-align: center;
					}

					hr {
						width: 100%;
						background-color: #000;
						margin: 10px 0;
					}

					p:first-child {
						margin: 10px 0;
					}

					p:last-child {
						color: ${lighten("#000", 0.4)};
					}
				}
			}
		}
	}

	.section_05 {
		display: flex;
		flex-flow: column;
		align-items: center;
		position: relative;
		margin-bottom: 25px;
		padding: 10px;

		.section_title {
			font-family: var(--rochester), sans-serif;
			font-size: 32px;
			margin-top: 35px;
		}

		.flower_07 {
			position: absolute;
			left: 0;
			top: 0;
		}
	}

	.section_06 {
		background: ${props => props.colormatrix.overlay};
		display: flex;
		flex-direction: column;
		align-items: center;
		position: relative;
		padding: 10px;

		.fader {
			height: 30px;
			width: 100%;
			background: ${props => props.colormatrix.fader};
			position: absolute;
			top: -20px;
		}

		.section_title {
			font-family: var(--league), sans-serif;
			color: ${props => props.colormatrix.font.primary};
			font-size: 28px;
			margin-bottom: 5px;
			margin-top: 30px;
		}

		.comment_text {
			font-family: var(--inter), sans-serif;
			font-size: 22px;
			padding: 5px;
		}

		.comment_sub_text {
			font-family: var(--inter), sans-serif;
			font-size: 18px;
			font-weight: 500;
			color: ${lighten("#000", 0.3)};
			text-align: center;
			padding: 5px;
			width: 90%;
		}
	}

	.section_09 {
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 10px 20px;
		margin-bottom: 30px;

		.divider {
			height: 1px;
			background: #f7f7f7;
			width: 100%;
			margin: 20px 0;
		}

		.section_title {
			font-family: var(--league), sans-serif;
			font-size: 28px;
			margin-bottom: 20px;
			margin-top: 10px;
		}

		.section_sub_title {
			font-family: var(--inter), sans-serif;
			font-size: 14px;
			font-weight: 500;
			color: ${lighten("#000", 0.5)};
			text-align: center;
			width: 90%;
		}

		.gift_input {
			border-radius: 5px;
			margin: 10px;
		}

		button {
			${props => common_btn(props)}
			margin-top: 15px;
			padding: 5px 40px;
			color: #fff;
		}
	}

	.section_07 {
		position: relative;
		background: ${props => props.colormatrix.overlay};
		.section_content {
			padding: 10px;
			position: relative;
			top: 0;
			z-index: 1;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			.section_title {
				font-family: var(--league), sans-serif;
				font-size: 28px;
				margin: 20px 0;
				color: ${props => props.colormatrix.font.primary};
			}

			.location_wrapper {
				background: #fff;
				margin: 20px;
				border-radius: 10px;
				display: flex;
				flex-direction: column;
				align-items: center;
				width: 340px;

				.location_text {
					text-align: center;
					font-family: var(--inter), sans-serif;
					font-size: 16px;
				}

				button {
					${props => common_btn(props)}
					padding: 5px 40px;
					color: #fff;
					margin: 15px;
				}
			}

			.partner_04_wrapper {
				border-radius: 20px;
				background: #fff;
				position: relative;
				box-shadow: 0 0 2px 2px #ebebeb;
				display: flex;
				.partner_04 {
					width: 220px;
					border-radius: 20px;
				}
			}

			.partners_text {
				font-family: var(--story), sans-serif;
				font-weight: bold;
				//z-index: 1;
				font-size: 26px;
			}

			.conclusion_text {
				//z-index: 1;
				font-size: 16px;
				font-weight: semiBold;
				text-align: center;
				padding: 10px;
			}
		}
		.flower_04 {
			position: absolute;
			bottom: -100px;
			left: -80px;
			width: 200px;
		}

		.flower_05 {
			position: absolute;
			bottom: -100px;
			right: -80px;
			width: 200px;
		}
	}

	.section_08 {
		background: ${props => darken(props.colormatrix.main, 0.2)};
		display: flex;
		justify-content: center;
		flex-direction: column;
		align-items: center;
		padding: 20px 0;
		position: relative;

		p {
			color: #fff;
			margin: 10px 0;
		}

		.social {
			cursor: pointer;
			text-decoration: none;
		}
	}
`;
